import Store from '@/store/computed/storeHelpers'
export default {
  asyncComputed: {
    async totalCost() {
      return await this.calculateTotal(this.trips, 'costTotal')
    },
    async totalSell() {
      return await this.calculateTotal(this.trips, 'sellTotal')
    },
    async totalHours() {
      return await this.calculateTotal(this.trips, 'hours')
    },
    async totalSiteWeight() {
      return await this.calculateTotal(this.trips, 'siteWeight')
    },
    async totalTipWeight() {
      return await this.calculateTotal(this.trips, 'tipWeight')
    },
    async totalScaleWeight() {
      return await this.calculateTotal(this.trips, 'scaleWeight')
    }
  },
  computed: {
    defaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'tripDefaultHeaders'
    })
  },

  data() {
    return {
      allPossibleHeaders: [
        {
          text: 'Trip ID',
          align: 'left',
          value: 'id',
          type: 'text',
          show: false
        },
        {
          text: 'Billing Period',
          align: 'left',
          value: 'docket.billingPeriod',
          type: 'text',
          show: false
        },
        {
          text: 'Date',
          align: 'left',
          value: 'docket.date',
          type: 'date',
          show: false
        },
        {
          text: 'Date Received',
          align: 'left',
          value: 'docket.dateReceived',
          type: 'date',
          show: false
        },
        {
          text: 'Reference',
          align: 'left',
          value: 'docket.externalRef',
          type: 'text',
          show: false
        },
        {
          text: 'Project',
          align: 'left',
          value: 'docket.site.project.name',
          type: 'text',
          show: false
        },
        {
          text: 'Site',
          align: 'left',
          value: 'docket.site.name',
          type: 'text',
          show: false
        },
        {
          text: 'Tip',
          align: 'left',
          value: 'tip.name',
          type: 'text',
          show: false
        },
        {
          text: 'Spoil',
          align: 'left',
          value: 'spoil.name',
          type: 'text',
          show: false
        },
        {
          text: 'Sub-contractor',
          align: 'left',
          value: 'docket.vehicle.contractor.name',
          type: 'text',
          show: false
        },
        {
          text: 'Vehicle',
          align: 'left',
          value: 'docket.vehicle.name',
          type: 'text',
          show: false
        },
        {
          text: 'Vehicle Type',
          align: 'left',
          value: 'docket.vehicle.vehicleType.name',
          type: 'text',
          show: false
        },
        {
          text: 'Driver',
          align: 'left',
          value: 'docket.driver.name',
          type: 'text',
          show: false
        },
        {
          text: 'Start',
          align: 'left',
          value: 'start',
          type: 'time',
          decimals: 1,
          show: false
        },
        {
          text: 'End',
          align: 'left',
          value: 'end',
          type: 'time',
          decimals: 1,
          show: false
        },

        {
          text: 'Billable Hours',
          align: 'right',
          value: 'hours',
          type: 'num',
          decimals: 1,
          show: false
        },
        {
          text: 'Breaks',
          align: 'right',
          value: 'breaks',
          type: 'num',
          decimals: 1,
          show: false
        },
        {
          text: 'Travel',
          align: 'right',
          value: 'travel',
          type: 'num',
          decimals: 1,
          show: false
        },
        {
          text: 'Tip / WB Weight',
          align: 'right',
          value: 'siteWeight',
          type: 'num',
          decimals: 2,
          show: false
        },
        {
          text: 'Site / LR Weight',
          align: 'right',
          value: 'tipWeight',
          type: 'num',
          decimals: 2,
          show: false
        },
        {
          text: 'Truck / Scale Weight',
          align: 'right',
          value: 'scaleWeight',
          type: 'num',
          decimals: 2,
          show: false
        },
        {
          text: 'Qty',
          align: 'right',
          value: 'qty',
          type: 'num',
          decimals: 0,
          show: false
        },
        {
          text: 'Cost Price',
          align: 'right',
          value: 'costPrice',
          type: 'curr',
          decimals: 2,
          show: false
        },
        {
          text: 'Cost Unit',
          align: 'center',
          value: 'costUnit',
          type: 'text',
          show: false
        },
        {
          text: 'Cost Total',
          align: 'right',
          value: 'costTotal',
          type: 'curr',
          decimals: 2,
          show: false
        },
        {
          text: 'Sell Price',
          align: 'right',
          value: 'sellPrice',
          type: 'curr',
          decimals: 2,
          show: false
        },
        {
          text: 'Sell Unit',
          align: 'center',
          value: 'sellUnit',
          type: 'text',
          show: false
        },
        {
          text: 'Sell Total',
          align: 'right',
          value: 'sellTotal',
          type: 'curr',
          decimals: 4,
          show: false
        },
        {
          text: 'Billed',
          align: 'right',
          value: 'approvedBillingAmount',
          type: 'curr',
          decimals: 4,
          show: false
        },
        {
          text: 'Waived',
          align: 'right',
          value: 'waivedAmount',
          type: 'curr',
          decimals: 4,
          show: false
        },
        {
          text: 'Outstanding',
          align: 'right',
          value: 'outstandingBillingAmount',
          type: 'curr',
          decimals: 4,
          show: false
        },
        {
          text: 'Rate ID',
          align: 'left',
          value: 'rateId',
          type: 'text',
          show: false
        },
        {
          text: 'Rate Type',
          align: 'left',
          value: 'rateType',
          type: 'text',
          show: false
        },
        {
          text: 'RCTI ID',
          align: 'left',
          value: 'rctiId',
          type: 'text',
          show: false
        },
        {
          text: "Admin Fee Req'd",
          align: 'left',
          value: 'rate.adminFeeRequired',
          type: 'num',
          decimals: 0,
          show: false
        },
        {
          text: 'Admin Fee %',
          align: 'right',
          value: 'docket.vehicle.contractor.adminFeePercentage',
          type: 'num',
          decimals: 0,
          show: false
        },
        {
          text: 'Bill ID',
          align: 'left',
          value: 'billId',
          type: 'text',
          show: false
        },
        {
          text: 'Type',
          align: 'left',
          value: 'docket.type',
          type: 'text',
          show: false
        },
        {
          text: 'W/B Docket #',
          align: 'left',
          value: 'wbDocketNumber',
          type: 'text',
          show: false
        },
        {
          text: 'Trip Notes',
          align: 'left',
          value: 'notes',
          type: 'text',
          show: false
        },
        {
          text: 'GPS Notes',
          align: 'left',
          value: 'GPSNotes',
          type: 'text',
          show: false
        },
        {
          text: 'Tipping Docket Notes',
          align: 'left',
          value: 'tippingDocketNotes',
          type: 'text',
          show: false
        },
        {
          text: 'Entered by',
          align: 'left',
          value: 'docket.createdBy.name',
          type: 'text',
          show: false
        },
        {
          text: 'Updated by',
          align: 'left',
          value: 'updatedBy.name',
          type: 'text',
          show: false
        },
        {
          text: 'Created At',
          align: 'left',
          value: 'createdAt',
          type: 'date',
          show: false
        },
        {
          text: 'Updated At',
          align: 'left',
          value: 'updatedAt',
          type: 'date',
          show: false
        },
        {
          text: 'Docket Updated At',
          align: 'left',
          value: 'docket.updatedAt',
          type: 'date',
          show: false
        },
        {
          text: 'Tipping Docket ID',
          align: 'left',
          value: 'tippingDocketLineId',
          type: 'text',
          show: false
        }
      ]
    }
  }
}
